/* eslint-disable linebreak-style */

const isEuropeRegion = (countryCode: string): boolean => ['CH', 'HU', 'CZ', 'PL', 'SI', 'NO', 'SE', 'FI', 'DK'].includes(countryCode);

const isEuropeRegionWithUKI = (countryCode: string): boolean => ['GB', 'IE', 'CH', 'HU', 'CZ', 'PL', 'SI'].includes(countryCode);

const isCountryCodeUS = (countryCode: string): boolean => ['US'].includes(countryCode);

const isCountryCodeUKI = (countryCode: string): boolean => ['GB', 'IE'].includes(countryCode);

const isCountyIntl = (countryCode: string): boolean => ['HU', 'CZ', 'GB', 'IE', 'NO', 'SI', 'PL', 'CH'].includes(countryCode);

export {
    isEuropeRegion, isEuropeRegionWithUKI, isCountryCodeUS, isCountryCodeUKI, isCountyIntl 
};
